<div class="analiz-panel">
  <nz-card nzTitle="Analiz" [nzBordered]="false">
    <nz-tabs nzSize="small" nzType="card">
      <!-- Tab 1: Statistics -->
      <nz-tab nzTitle="Istatistikler">
        <div class="stats-container">
          <div class="stat-item">
            <i nz-icon nzType="dashboard" class="stat-icon"></i>
            <div class="stat-content">
              <span class="stat-label">FPS</span>
              <span class="stat-value">{{ formatSayi(istatistikDegeriAl('fps'), 0) }}</span>
            </div>
          </div>

          <div class="stat-item">
            <i nz-icon nzType="dot-chart" class="stat-icon"></i>
            <div class="stat-content">
              <span class="stat-label">Parcacik Sayisi</span>
              <span class="stat-value">{{ istatistikDegeriAl('parcacikSayisi') | number }}</span>
            </div>
          </div>

          <div class="stat-item">
            <i nz-icon nzType="pie-chart" class="stat-icon"></i>
            <div class="stat-content">
              <span class="stat-label">Dolum Yuzdesi</span>
              <span class="stat-value">{{ formatSayi(istatistikDegeriAl('dolumYuzdesi'), 1) }}%</span>
            </div>
          </div>

          <div class="stat-item">
            <i nz-icon nzType="clock-circle" class="stat-icon"></i>
            <div class="stat-content">
              <span class="stat-label">Sim Zamani</span>
              <span class="stat-value">{{ formatSayi(istatistikDegeriAl('simZaman'), 2) }}s</span>
            </div>
          </div>

          <div class="stat-item">
            <i nz-icon nzType="thunderbolt" class="stat-icon"></i>
            <div class="stat-content">
              <span class="stat-label">Toplam Enerji</span>
              <span class="stat-value">{{ formatSayi(istatistikDegeriAl('toplamEnerji'), 1) }} J</span>
            </div>
          </div>

          <div class="stat-item">
            <i nz-icon nzType="rocket" class="stat-icon"></i>
            <div class="stat-content">
              <span class="stat-label">Max Hiz</span>
              <span class="stat-value">{{ formatSayi(istatistikDegeriAl('maxHiz'), 2) }} m/s</span>
            </div>
          </div>

          <div class="stat-item">
            <i nz-icon nzType="block" class="stat-icon"></i>
            <div class="stat-content">
              <span class="stat-label">Ortalama Densitesi</span>
              <span class="stat-value">{{ formatSayi(istatistikDegeriAl('ortalamaDensitesi'), 1) }} kg/m³</span>
            </div>
          </div>
        </div>
      </nz-tab>

      <!-- Tab 2: Sensors -->
      <nz-tab nzTitle="Sensorler">
        <div class="sensors-container">
          <div *ngFor="let sensor of ornekSensorler" class="sensor-item">
            <div class="sensor-header">
              <div class="sensor-baslik">
                <nz-badge [nzColor]="getSensorRengi(sensor.tip)"></nz-badge>
                <span class="sensor-ad">{{ sensor.ad }}</span>
              </div>
              <span class="sensor-deger">{{ degerFormatla(sensor.deger, sensor.birim) }}</span>
            </div>

            <div class="sensor-grafik">
              <!-- Mini graph placeholder -->
              <div class="mini-chart">
                <svg width="100%" height="40" preserveAspectRatio="none">
                  <polyline
                    [attr.points]="'0,30 20,25 40,20 60,15 80,22 100,18'"
                    [attr.stroke]="getSensorRengi(sensor.tip)"
                    stroke-width="2"
                    fill="none" />
                  <polyline
                    [attr.points]="'0,40 0,30 20,25 40,20 60,15 80,22 100,18 100,40'"
                    [attr.fill]="getSensorRengi(sensor.tip)"
                    fill-opacity="0.2"
                    stroke="none" />
                </svg>
              </div>
            </div>
          </div>

          <nz-divider></nz-divider>

          <button nz-button nzType="dashed" nzBlock>
            <i nz-icon nzType="plus"></i>
            Yeni Sensor Ekle
          </button>
        </div>
      </nz-tab>

      <!-- Tab 3: Heatmap -->
      <nz-tab nzTitle="Heatmap">
        <div class="heatmap-container">
          <div class="heatmap-grid">
            <div
              *ngFor="let heatmap of heatmapTipleri"
              class="heatmap-card"
              [class.secili]="seciliHeatmap === heatmap.id"
              (click)="heatmapSec(heatmap.id)"
              nz-tooltip
              [nzTooltipTitle]="heatmap.aciklama">
              <i nz-icon [nzType]="heatmap.ikon" class="heatmap-ikon"></i>
              <span class="heatmap-ad">{{ heatmap.ad }}</span>
              <i
                *ngIf="seciliHeatmap === heatmap.id"
                nz-icon
                nzType="check-circle"
                nzTheme="fill"
                class="check-icon">
              </i>
            </div>
          </div>

          <nz-divider></nz-divider>

          <div class="heatmap-ayarlar">
            <h4>Heatmap Ayarlari</h4>
            <p class="ayar-aciklama">
              Secili: <strong>{{ heatmapTipleri[seciliHeatmap]?.ad }}</strong>
            </p>
          </div>
        </div>
      </nz-tab>

      <!-- Tab 4: Report -->
      <nz-tab nzTitle="Rapor">
        <div class="rapor-container">
          <div class="rapor-bilgi">
            <i nz-icon nzType="file-text" style="font-size: 48px; color: #4ecca3;"></i>
            <h3>Simulasyon Raporu</h3>
            <p>Simulasyon sonuclarini rapor olarak disari aktarin.</p>
          </div>

          <nz-divider></nz-divider>

          <div class="export-secenekler">
            <h4>Dosya Formati Secin</h4>
            <div class="format-grid">
              <div
                *ngFor="let format of dosyaFormatlari"
                class="format-card"
                (click)="dosyaFormatSec(format.deger)">
                <i nz-icon [nzType]="format.ikon" class="format-ikon"></i>
                <span class="format-etiket">{{ format.etiket }}</span>
              </div>
            </div>
          </div>

          <nz-divider></nz-divider>

          <button nz-button nzType="primary" nzBlock nzSize="large" (click)="raporOlusturTikla()">
            <i nz-icon nzType="download"></i>
            Rapor Olustur
          </button>
        </div>
      </nz-tab>
    </nz-tabs>
  </nz-card>
</div>
